import { BetOffering, ApiBetOffering } from '@api/types';

const SUPPORTED_BET_SHORT_CODES_MAP = {
  SG: true,
  ESG: true,
  SGI: true,
  SP: true,
  ESP: true,
  SPI: true,
  RP: true,
  ERP: true,
  CG: true,
  ECG: true,
  CP: true,
  ECP: true,
  CO: true,
  ECO: true,
  EA: true,
  COI: true,
  TR: true,
  ETR: true,
  TO: true,
  ETO: true,
  S4: true,
  ES4: true,
  TA: true,
  TOI: true,
  MM: true,
  EMM: true,
  MI: true,
  EMI: true,
  T: true,
  ET: true,
  C4: true,
  EC4: true,
  CT: true,
  ECT: true,
  QP: true,
  EQP: true,
  QN: true,
  EQN: true,
  T3: true,
  ET3: true,
  P5: true,
  SP5: true,
  EP5: true,
  ESP5: true,
  EB5: true,
} satisfies Record<BetOffering['betShortCode'], true>;

const SUPPORTED_BET_SHORT_CODES = new Set(
  Object.keys(SUPPORTED_BET_SHORT_CODES_MAP) as BetOffering['betShortCode'][]
);

const isSupportedBet = (betOffering: ApiBetOffering): betOffering is BetOffering =>
  SUPPORTED_BET_SHORT_CODES.has(betOffering.betShortCode as BetOffering['betShortCode']);

const filterUnsupportedBetShortCode = (
  betsOffering: ApiBetOffering[] | null
): BetOffering[] | null => (betsOffering ? betsOffering.filter(isSupportedBet) : null);

export { filterUnsupportedBetShortCode };
